import { axiosWithAuth } from "@/lib/AxiosClient";

export interface Species {
  id: string;
  name: string;
  siteId: string;
  tenantId: string;
  scientificName: string;
  majorCategory: string;
  prioritySpecies: boolean;
  flagshipSpecies: boolean;
  active: boolean;
  notes: string | null;
}

export class SpeciesService {
  private static readonly BASE_PATH = "/api/species";
  private static instance = axiosWithAuth;

  static async getById(speciesId: string): Promise<Species> {
    const response = await this.instance.get<Species>(`${this.BASE_PATH}/${speciesId}`);
    return response.data;
  }

  static async create(species: Omit<Species, "id">): Promise<Species> {
    const response = await this.instance.post<Species>(this.BASE_PATH, species);
    return response.data;
  }

  static async update(speciesId: string, species: Species): Promise<void> {
    await this.instance.put<void>(`${this.BASE_PATH}/${speciesId}`, species);
  }

  static async getBySiteId(siteId: string): Promise<Species[]> {
    const response = await this.instance.get<Species[]>(`${this.BASE_PATH}/site/${siteId}`);
    return response.data;
  }

  static async delete(speciesId: string): Promise<void> {
    await this.instance.delete<void>(`${this.BASE_PATH}/${speciesId}`);
  }
}
